import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
    padding: theme.spacing(8),
    backgroundColor: theme.colorPalette.white,
    borderRadius: theme.sizes.roundCorners
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(4)
  },
  actions: {
    display: 'flex',
    flexShrink: 0,
    gap: theme.spacing(2)
  },
  // MuiButton.root pins height to 36, so a wrapped label has nowhere to go and crams.
  actionButton: {
    whiteSpace: 'nowrap'
  },
  metaGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: theme.spacing(3)
  },
  metaItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  countValue: {
    fontSize: 24,
    fontWeight: 600,
    color: theme.colorPalette.orange_50
  },
  backLink: {
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    cursor: 'pointer',
    color: theme.colorPalette.orange_50,
    fontSize: 14,
    fontWeight: 600
  },
  backIcon: {
    width: 24,
    height: 24
  },
  csvList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1)
  },
  tableLink: {
    fontSize: 14,
    fontWeight: 400
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  feed: {
    maxHeight: 320,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(3),
    backgroundColor: theme.colorPalette.beige_25,
    borderRadius: theme.sizes.roundCorners
  },
  tableScroll: {
    overflowX: 'auto'
  },
  // CollapsibleSection brings its own card padding; this only restores the gap between siblings.
  resultsSection: {
    marginBottom: theme.spacing(2)
  },
  timeline: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  // Horizontal rail: four equal columns, each node's connector running right to the next dot. The
  // last node carries no connector, so the rail ends at it.
  timelineRail: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  timelineNode: {
    display: 'flex',
    flexDirection: 'column',
    // Equal widths keep the dots evenly spaced; minWidth 0 lets a long label wrap rather than
    // stretching its column and skewing the rail.
    flex: 1,
    minWidth: 0
  },
  timelineMarker: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  timelineDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    flexShrink: 0,
    backgroundColor: theme.colorPalette.beige_50
  },
  timelineDotReached: {
    backgroundColor: theme.colorPalette.green_100
  },
  timelineDotSuccess: {
    backgroundColor: theme.colors.success
  },
  timelineDotWarning: {
    backgroundColor: theme.colorPalette.orange_50
  },
  timelineDotError: {
    backgroundColor: theme.colors.error
  },
  timelineLine: {
    flexGrow: 1,
    height: 2,
    backgroundColor: theme.colorPalette.beige_50
  },
  timelineLineReached: {
    backgroundColor: theme.colorPalette.green_100
  },
  timelineContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(2),
    // Keeps a long value clear of the next column's dot.
    paddingRight: theme.spacing(4)
  },
  timelinePending: {
    opacity: 0.5
  },
  staleWarning: {
    color: theme.colors.error
  },
  engineerDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    backgroundColor: theme.colorPalette.beige_25,
    borderRadius: theme.sizes.roundCorners
  },
  monospace: {
    wordBreak: 'break-all'
  },
  errorCell: {
    color: theme.colors.error,
    maxWidth: 420,
    wordBreak: 'break-word'
  }
});

export default makeStyles(styles);
